export default function ugcVideosController() {
  const ugcVideosSection = document.querySelector('.ugc-videos');

  if (!ugcVideosSection) {
    return;
  }

  const swiper = new Swiper('.ugc-videos__swiper', {
    slidesPerView: 2.4,
    spaceBetween: 10,
    loop: true,
    effect: 'slide',
    breakpoints: {
      500: {
        slidesPerView: 3,
        centeredSlides: false,
        loop: true,
      },
    },
  });

  const slides = document.querySelectorAll('.ugc-videos .swiper-slide');

  function playActiveSlideVideo() {
    const activeSlide = document.querySelector('.ugc-videos .swiper-slide-active');
    const video = activeSlide?.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play();

      slides.forEach((slide) => {
        const v = slide.querySelector('video');
        if (v) {
          v.onended = null;
        }
      });

      video.onended = () => {
        swiper.slideNext();
        setTimeout(playActiveSlideVideo, 10);
      };
    }
  }

  swiper.on('slideChangeTransitionEnd', playActiveSlideVideo);

  playActiveSlideVideo();
}
